export default __webpack_public_path__ + "static/2289-325907e95e42ad2e12865261ce24538b.gif";